import { render } from "./loader-transactions.vue?vue&type=template&id=ac3a28e0&ts=true"
import script from "./loader-transactions.vue?vue&type=script&lang=ts"
export * from "./loader-transactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__